import angular from 'angular';

angular.module('cloudX').directive('cxRelationHandlingLevelsButtonGroup', [
  'enumCacheSvc',
  '$filter',
  '$rootScope',
  function(enumCacheSvc, $filter, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        ngChange: '&?',
      },
      require: 'ngModel',
      template: `
        <div role="group" aria-label="relationHandlingLevels" class="btn-group btn-group-justified">
          <button ng-repeat="t in items track by t.id"
                  ng-click="toggleRelationHandlingLevels(t.id)"
                  type="button"
                  title="{{t.label}}"
                  class="btn btn-default no-overflow"
                  ng-class="{active: selectedHandlingLevels.includes(t.id)}">
            <i class="fa fa-fw margin5R fa-inline"
               ng-class="{
                 '': t.id === 1,
                 'fa-exclamation-triangle text-warning': t.id === 2,
                 'fa-exclamation-triangle text-danger': t.id === 3
               }"></i>
            {{t.label}}
          </button>
        </div>`,
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;

        $scope.items = [];
        $scope.selectedHandlingLevels = [];

        enumCacheSvc.get('relationhandlinglevel').then(function(data) {
          $scope.items = data.map(x => ({ id: x.key, value: x.value, label: x.value }));
          translateLabels();
        });
        function translateLabels() {
          $scope.items.forEach(function(item) {
            item.label = $filter('translateList')(item.id, 'relationHandlingLevel', item.value);
          });
        }
        var deregistration = $rootScope.$on('$translateChangeSuccess', translateLabels);
        $scope.$on('$destroy', deregistration);

        $scope.toggleRelationHandlingLevels = function(relHandlingLevel) {
          const idx = $scope.selectedHandlingLevels.indexOf(relHandlingLevel);
          if (idx >= 0) {
            $scope.selectedHandlingLevels.splice(idx, 1);
          } else {
            $scope.selectedHandlingLevels.push(relHandlingLevel);
          }
          ngModel.$setViewValue([...$scope.selectedHandlingLevels]);
          if ($scope.ngChange) $scope.ngChange();
        };
        ngModel.$render = function() {
          var value = ngModel.$viewValue;
          if (value !== null && typeof value !== 'undefined') {
            $scope.selectedHandlingLevels = [...value];
          }
        };
      },
    };
  },
]);
